<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('EditDailyReport') | ToUppercase">
                <small>{{ $t("Name") | ToUppercase }}</small><br />
                <vs-input class="w-full" type="text" name="name" v-model="dailyReport.name"/>

                <small>{{$t('Date') |ToUppercase}}</small><br>
                <datepicker v-model="dailyReport.date"></datepicker>

                <small>{{$t('Shift') |ToUppercase}}</small><br>
                <vs-select v-model="selectedShift" class="selectExample w-full mb-6">
                    <vs-select-item v-for="(item,index) in shifts" :key="index" :text="item.name" :value="item.id"/>
                </vs-select>

                <small>{{$t('Report') |ToUppercase}}</small><br>
                <quill-editor v-model="dailyReport.document_content"></quill-editor>

                <div class="mt-6">
                    <vs-button class="mr-2" @click="editDailyReport">{{ $t("Edit") | ToUppercase }}</vs-button>
                    <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'

    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker,
            quillEditor
        },
        data() {
            return {
                selectedShift: 0,
                shifts: [],
                dailyReport: {}
            };
        },
        methods: {
            updateShifts() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/shift/')
                .then(function (response) {
                    thisIns.shifts = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju izmen",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            updateDailyReport() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/report/' + this.$route.params.report_id + '?type=daily')
                .then(function (response) {
                    thisIns.dailyReport = response.data;
                    thisIns.selectedShift = response.data.shiftID;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju dnevnih poročil.",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            editDailyReport() {
                this.$vs.loading();
                
                const thisIns = this;
                this.$http.put('/report/' + this.$route.params.report_id + '?type=daily', {
                    id: thisIns.dailyReport.id,
                    name: thisIns.dailyReport.name,
                    date: thisIns.dailyReport.date,
                    shiftID: thisIns.selectedShift,
                    document_content: thisIns.dailyReport.document_content,
                }).then(function () {
                    thisIns.$vs.notify({
                        text: "Dnevno poročilo shranjeno",
                        color: "success",
                    });
                    thisIns.$router.push('/report/daily');
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri shranjevanju",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            }
        },
        created() {
            this.updateDailyReport();
            this.updateShifts();
        },
    };
</script>